import "./utils/installPromptCapture";
import "regenerator-runtime/runtime";
import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import ServiceWorkerUpdater from "./components/ServiceWorkerUpdater";
import { isMorningReportDomain } from "features/morningReport/morningReportPaths";

// index.html says HealthDesk; MorningReport's own domain names itself.
if (isMorningReportDomain()) document.title = "MorningReport";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <>
    <ServiceWorkerUpdater />
    <App />
  </>
);
